export default {
    GET_INTEGRATIONS: state => state.integrations,
    IS_PRESENT: (state) => (name) => !!_.find(state.integrations, {
        integrationCompanyType: name,
    }),
}
